export class ITypeReport {
  id?: number | null = null;
  type: string = "";
}